// @ts-nocheck
import { auth } from '../firebase.config';
import React, { useState } from 'react';
import DefaultProfileImage from '../Svgs/DefaultProfile.svg'; // You'll need to add this asset

const PersonFinderDialog = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        company: "",
    });

    const [personData, setPersonData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation: Either name or email must be provided, and company is always required
        if (formData.email) {
            // If email is provided, validate email format
            if (!isValidEmail(formData.email)) {
                setError("Please enter a valid email address");
                return;
            }
            // When searching by email, company is optional
        } else {
            // When searching by name, company is required
            if (!formData.company) {
                setError("Please provide company name when searching by person's name");
                return;
            }
            
            // At least name must be provided if not searching by email
            if (!formData.name) {
                setError("Please provide either a person's name or professional email");
                return;
            }
        }
    
        setError("");
        setIsLoading(true);

        try {
            const token = await auth.currentUser.getIdToken(true);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/person-lookup`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    name: formData.name || null,
                    email: formData.email || null,
                    company: formData.company || null,
                }),
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    setError("Authentication error. Please try again.");
                    setIsLoading(false);
                    return;
                }
                throw new Error("Failed to get response");
            }

            const data = await response.json();
            setPersonData(data);
            setFormData({
                name: "",
                email: "",
                company: "",
            })
            setIsLoading(false);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch person information. Please try again.");
            setIsLoading(false);
        }
    };

    const handleReset = () => {
        setPersonData(undefined);
        setError("");
    };

    return (
        <div className="copilots-dialog-overlay">
            <div className="copilots-dialog overflow-hidden shadow-lg rounded-2xl" style={{ maxWidth: "800px", height: "90%" }}>
                <div className="w-full p-5 bg-white flex justify-between border-b">
                    <h2 className='text-xl font-semibold'>Professional Search</h2>
                    <button onClick={() => onClose(false)} className="close-button w-10 h-10 rounded-full">×</button>
                </div>
                {isLoading ? 
                    <div className='max-w-3xl p-6 bg-white h-5/6 flex justify-center items-center'>
                        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
                    </div>
                : 
                    <div className="max-w-3xl p-6 bg-white h-5/6 overflow-y-auto scrollbar-thin">
                        {error && (
                            <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
                                {error}
                            </div>
                        )}
                        
                        {personData ?
                            <PersonProfile 
                                personData={personData} 
                                onBack={handleReset}
                            />
                        : 
                        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6">
                        {/* Option 1: Search by Name and Company */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="col-span-1">
                                <label className="block text-gray-700 font-medium text-start">Company Name </label>
                                <input
                                    type="text"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    placeholder="Enter company name"
                                    className="w-full mt-1 p-2 border rounded-lg outline-gray-400 border-gray-200"
                                />
                                <p className="text-xs text-gray-500 mt-1 text-start">
                                    The company where the person works
                                </p>
                            </div>
                    
                            <div className="col-span-1">
                                <label className="block text-gray-700 font-medium text-start">Person's Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter full name"
                                    className="w-full mt-1 p-2 border rounded-lg outline-gray-400 border-gray-200"
                                />
                                <p className="text-xs text-gray-500 mt-1 text-start">
                                    First and last name of the person
                                </p>
                            </div>
                        </div>
                    
                        {/* OR Divider */}
                        <div className="flex items-center my-2">
                            <div className="flex-grow h-px bg-gray-300"></div>
                            <div className="mx-4 font-medium text-gray-500">OR</div>
                            <div className="flex-grow h-px bg-gray-300"></div>
                        </div>
                    
                        {/* Option 2: Search by Professional Email */}
                        <div className="col-span-1">
                            <label className="block text-gray-700 font-medium text-start">Professional Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter professional email address"
                                className="w-full mt-1 p-2 border rounded-lg outline-gray-400 border-gray-200"
                            />
                            <p className="text-xs text-gray-500 mt-1 text-start">
                                Search using just the corporate email address
                            </p>
                        </div>
                    
                        {/* Submit Button */}
                        <div className="col-span-1 w-full flex justify-end mt-4">
                            <button
                                type="submit"
                                className="w-fit py-2 px-4 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition duration-300"
                            >
                                Search
                            </button>
                        </div>
                    </form>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

const PersonProfile = ({ personData, onBack }) => {
    // Extract data with fallbacks for potentially missing fields
    const {
        name,
        current_position,
        professional_background,
        company_overview,
        contact_information,
        additional_notes
    } = personData;

    // Default image if not provided
    const profileImage = DefaultProfileImage; // You can replace this with a default profile image
    return (
        <div className='w-full h-full flex flex-col gap-5'>
            <button 
                onClick={onBack}
                className="self-start text-blue-600 flex items-center mb-2"
            >
                ← Back to search
            </button>
            
            <div className="bg-white shadow-lg rounded-lg p-6 border border-gray-200">
                <div className="flex items-start gap-6 mb-6">
                    <div className='w-full flex flex-col gap-1 justify-start items-start'>
                        <h2 className="text-2xl font-bold text-gray-800">{name || "Name not available"}</h2>
                        <h3 className="text-lg text-blue-600 font-medium">
                            {current_position?.role || "Role not available"} {current_position?.role && "at"} {current_position?.organization || company_overview?.name || ""}
                        </h3>
                        
                        {contact_information?.email && (
                            <p className="text-sm text-gray-600 mt-1">
                                <span className="font-semibold">Email:</span> {contact_information.email}
                            </p>
                        )}
                        
                        {contact_information?.website && (
                            <p className="text-sm text-gray-600">
                                <span className="font-semibold">Website:</span> <a href={contact_information.website} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{contact_information.website}</a>
                            </p>
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-6">
    {/* Professional Background Section */}
    <div className="col-span-1 text-left">
        <h3 className="font-semibold text-gray-800 mb-2 text-lg text-left">Professional Background</h3>
        <p className="text-gray-700 text-left">{professional_background || "No professional background available"}</p>
    </div>
    
    {/* Company Overview Section */}
    <div className="col-span-1 text-left">
    {additional_notes && (
        <div className="col-span-1 text-left">
            <h3 className="font-semibold text-gray-800 mb-2 text-lg text-left">Other Details</h3>
            <div className="bg-blue-50 p-4 rounded-lg text-left">
                <p className="text-gray-700 text-left">{additional_notes}</p>
            </div>
        </div>
    )}
        <h3 className="font-semibold text-gray-800 mb-2 text-lg text-left">Company Overview</h3>
        <div className="bg-gray-50 p-4 rounded-lg text-left">
            <h4 className="font-bold text-gray-800 text-left">{company_overview?.name || "Company name not available"}</h4>
            
            {company_overview?.industry?.length > 0 && (
                <p className="text-sm text-gray-700 mt-2 text-left">
                    <span className="font-semibold">Industry:</span> {company_overview.industry.join(", ")}
                </p>
            )}
            
            {company_overview?.headquarters && (
                <p className="text-sm text-gray-700 text-left">
                    <span className="font-semibold">Headquarters:</span> {company_overview.headquarters}
                </p>
            )}
            
            {company_overview?.employee_count && (
                <p className="text-sm text-gray-700 text-left">
                    <span className="font-semibold">Size:</span> {company_overview.employee_count}
                </p>
            )}
            
            {company_overview?.mission && (
                <div className="mt-2 text-left">
                    <p className="text-sm text-gray-700 font-semibold text-left">Mission:</p>
                    <p className="text-sm text-gray-700 italic text-left">"{company_overview.mission}"</p>
                </div>
            )}
        </div>
    </div>

    <div className="col-span-1 text-left">
        <h3 className="font-semibold text-gray-800 mb-2 text-lg text-left">Contact Information</h3>
        <div className="bg-gray-50 p-4 rounded-lg text-left">
            {contact_information?.email && (
                <p className="text-sm text-gray-700 text-left">
                    <span className="font-semibold">Email:</span> {contact_information.email}
                </p>
            )}
            
            {contact_information?.phone?.length > 0 && (
                <p className="text-sm text-gray-700 mt-2 text-left">
                    <span className="font-semibold">Phone:</span> {contact_information.phone.join(", ")}
                </p>
            )}
            
            {contact_information?.website && (
                <p className="text-sm text-gray-700 mt-2 text-left">
                    <span className="font-semibold">Website:</span> <a href={contact_information.website} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{contact_information.website}</a>
                </p>
            )}
        </div>
    </div>
                </div>

                <div className="mt-8 flex justify-center">
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        <a
                            href={`mailto:${contact_information?.email || ''}`}
                            className={`bg-blue-600 py-2 px-4 text-white text-center rounded hover:bg-blue-700 transition ${!contact_information?.email && 'opacity-50 cursor-not-allowed'}`}
                            disabled={!contact_information?.email}
                        >
                            Send Email
                        </a>
                        <a
                            href={`https://linkedin.com/search/results/people/?keywords=${encodeURIComponent(name || '')}+${encodeURIComponent(company_overview?.name || '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-blue-800 py-2 px-4 text-white text-center rounded hover:bg-blue-900 transition"
                        >
                            Find on LinkedIn
                        </a>
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(JSON.stringify(personData, null, 2));
                                alert('Person data copied to clipboard');
                            }}
                            className="bg-gray-600 py-2 px-4 text-white text-center rounded hover:bg-gray-700 transition"
                        >
                            Copy Data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonFinderDialog;